
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Header from '../header'
import Footer from '../footer'
import { Route, NavLink, HashRouter } from "react-router-dom";
import { BrowserRouter, Switch } from 'react-router-dom'
import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect'
import { routerActions } from 'react-router-redux'

import Login from '../user/login'
import Home from '../home'
import User from '../user'
import Page from '../page'
import ListBlogs from '../listBlogs'
import Offer from '../offer'
import UserRegister from '../user/register'
import PartnerRegister from '../partner/register'
import PartnerFAQs from '../partnerfaqs'
import $ from 'jquery'
import { userIsLogoutRedir, userIsLoginRedir, partnerIsLogoutRedir, partnerIsLoginRedir } from '../../auth'
import SpaDetails from '../spaDetails'
import ListSpas from '../listSpas'
import BlogDetails from '../blogDetails'
import ScrollUpButton from "react-scroll-up-button";
import PartnerLogin from '../partner/login'
import Partner from '../partner'
import Verify from '../verify'
export class HomePage extends Component {

    render() {
        return (
            <BrowserRouter>
                <div>
                    <Header />
                    <div id="main_contain">
                        <Switch>
                            <Route exact path="/" component={Home} />
                            <Route exact path="/login" component={userIsLoginRedir(Login)} />
                            <Route exact path="/user*" component={userIsLogoutRedir(User)} />
                            <Route exact path="/pages/:slug" component={Page} />
                            <Route exact path="/blog/category/:slug/:page?" component={ListBlogs} />
                            <Route exact path="/blogs/:page?" component={ListBlogs} />
                            <Route exact path="/offers" component={Offer} />
                            <Route exact path='/register' component={UserRegister} />
                            <Route exact path="/spa" component={ListSpas} />
                            <Route exact path="/spa/:slug" component={SpaDetails} />
                            <Route exact path="/blog/:slug" component={BlogDetails} />
                            <Route exact path="/register-partner" component={PartnerRegister} />
                            <Route exact path="/partner/login" component={partnerIsLoginRedir(PartnerLogin)} />
                            <Route exact path="/partner*" component={partnerIsLogoutRedir(Partner)} />
                            <Route exact path="/faqs*" component={PartnerFAQs} />
                            <Route exact path="/verify" component={Verify} history={this.props.history} />
                        </Switch>
                    </div>
                    <Footer />
                    <ScrollUpButton
                        className="bnt_totop"
                        StopPosition={0}
                        TransitionBtnPosition={100}
                        EasingType='easeOutCubic'
                        AnimationDuration={500}
                    />
                </div>
            </BrowserRouter>
        )
    }
}

export default HomePage


// WEBPACK FOOTER //
// ./src/components/mainPage/index.js